import React, {useEffect, useState} from "react";
import {Button, Grid, Typography} from "@mui/material";
import useChallengeOpsStyle from "../../styles/challengeUntold/challengeOps";
import kozel_meeet from '../../assets/images/kozel_meet/meet_logo.png';
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import clsx from "clsx";
import {useAppSelector} from "../../stores/store";
import {gameNameApi} from "../ChallengeUntold";
import useActivity from "../../hooks/useActivity";
import PopupComponent from "../kozel/PopupComponent";
import map_challenge_untold from "../../assets/images/untold/map_challenge_untold.png";

const ChallengeOps: React.FC = () => {
    const styles = useChallengeOpsStyle();
    const {games} = useAppSelector(state => state.game);
    const {state} = games[gameNameApi];
    const {registerActivity} = useActivity();
    const [isOpenPopupMap, setIsOpenPopupMap] = useState(false);

    useEffect(() => {
        registerActivity({
            name: 'UNTOLD_CHALLENGE_FAIL',
            payload: {},
            callback: () => {
            },
        })
    }, []);

    return <Grid container className={styles.container}>
        <Grid item xs={12} lg={6} className={styles.item}>
            <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
        </Grid>
        <Grid item xs={12} lg={6} className={clsx(styles.item, styles.wrapperTeaserFrame)}>
            <TeaserFrame2
                title={<Typography className={styles.teaserFrameTitle}>Ooops!</Typography>}
                backgroundBoxTitle={theme.colors.dark_chocolate}
                titleMarginTop={'min(-5vh,-5vw)'}
            >
                <Grid container className={styles.teaserContainer}>
                    <Grid item xs={12} className={styles.teaserItem}>
                        <Typography className={styles.teaserTitle}>You got the challenges order wrong :)</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.teaserItem} flexDirection={'column'}>
                        <Typography className={styles.teaserText}>
                            {state && state.lastStep === null && 'Please go to challenge 1. (scan the correct totem)'}
                            {state && state.lastStep === 1 && 'Please go to challenge 2. (scan the correct totem)'}
                            {state && state.lastStep === 2 && 'Please go to challenge 3. (scan the correct totem)'}
                            {state && state.lastStep === 3 && 'Please go to challenge 4. (scan the correct totem)'}
                        </Typography>
                        <Typography className={styles.teaserText}>
                            Ask for help from the brand ambassador or visit <Button onClick={() => {setIsOpenPopupMap(true)}}>the challenge map here</Button> and identify each totem and its order.
                        </Typography>
                        <Typography className={styles.teaserTextSuccess}><b>Good luck!</b></Typography>
                    </Grid>
                </Grid>
            </TeaserFrame2>
        </Grid>
        <PopupComponent isOpen={isOpenPopupMap} onClose={() => {setIsOpenPopupMap(false)}}>
            <img src={map_challenge_untold} alt={'map_challenge_untold'} className={styles.img}/>
        </PopupComponent>
    </Grid>
}

export default ChallengeOps;